
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {WorkerAddRequestType} from "@/form/workerAdd/workerAdd.types";
import { fio } from "@/utils/validators";
import {IPosition, PositionName} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import { ICms_Category } from "@/entity/staff/staff.types";
import dayjs, { Dayjs } from 'dayjs';

@Component
export default class WorkerAddForm extends Form{
    @Validate(fio, i18nText("Введите ФИО с большой буквы"))
    fio = '';
    @Validate(required, i18nText("Выберите статус"))
    status_id = null;
    @Validate(required, i18nText("Выберите должность"))
    position_id = null;
    //@Validate(required, 'Выберите схему зп')
    salary = null;
    phone = '';
    salon_id = 0;
    @Validate(requiredIf(function (vm): boolean {
        return vm.position_id === vm.positionsList.find((el: IPosition) => el.name === vm.positionName.COSMETOLOG).id
    }), i18nText("Введите категорию"))
    cosmetolog_category_id = null;
    @Validate(required, i18nText("Введите день рождения"))
    birth_date = '';
    @Validate(required, i18nText("Введите дату приема на работу"))
    employment_date = '';
    description = '';
    positionName = PositionName;
    positionsList: IPosition[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    categoryList: ICms_Category[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    statusList: IStatus[] = [
        {id: null, name: i18nText("Не выбрано")}
    ]
    salaryList: ISalaryScheme[] = [
        {id: null, name: i18nText("Не выбрано"), type: true}
    ]
    disabledBirthDate(current: Dayjs): any {
        return current > dayjs().add(1, 'day').startOf('day');
    }
    disabledDate(current: Dayjs): any {
        return current < dayjs().add(1, 'day').startOf('day');
    }
    getFormData(): WorkerAddRequestType {
        return {
            name: this.fio.split(' ')[1],
            last_name: this.fio.split(' ')[0],
            middle_name: this.fio.split(' ')[2],
            status_id: this.status_id,
            phone: this.phone,
            salon_id: this.salon_id,
            cosmetolog_category_id: this.cosmetolog_category_id,
            birth_date: this.birth_date,
            employment_date: this.employment_date,
            description: this.description,
            position_id: this.position_id,
            salary_schema_id: this.salary
        }
    }
    setFormData(positions: IPosition[], category: ICms_Category[], statuses: IStatus[], salary: ISalaryScheme[], salon: number): void {

        if(positions.length) positions.forEach(el => this.positionsList.push(el));
        if(category.length) category.forEach(el => this.categoryList.push(el));
        if(statuses.length) statuses.forEach(el => this.statusList.push(el));
        if(salary.length) salary.forEach(el => this.salaryList.push(el));

        this.salon_id = salon;
    }

    setFormDataWithoutId(positions: IPosition[], category: ICms_Category[], statuses: IStatus[], salary: ISalaryScheme[]){
        positions.forEach(el => this.positionsList.push(el));
        category.forEach(el => this.categoryList.push(el));
        statuses.forEach(el => this.statusList.push(el));
        salary.forEach(el => this.salaryList.push(el));
    }
}
